// Should this Enter keypress send the message, or is it confirming an IME
// conversion?
//
// Students type Japanese, where Enter commits the kanji candidate BEFORE it
// ever means "send". Submitting on the confirming press posts half-converted
// text — which is why a working Enter-to-send still read as broken and was
// reported as a missing feature.
//
// Two signals, because one is not enough:
//   isComposing  the standard flag; correct on Chrome and Firefox.
//   keyCode 229  the legacy "IME is handling this key" code. Safari/WebKit
//                still reports it on the confirming keydown WHILE isComposing
//                reads false, so a check on isComposing alone fails there —
//                and Safari is a supported browser for this study.
export function shouldSubmitOnEnter(event) {
  if (!event || event.key !== 'Enter' || event.shiftKey) return false;
  const native = event.nativeEvent || event;
  return !(native.isComposing || native.keyCode === 229);
}

export default shouldSubmitOnEnter;
